// Dup'd from src/config/avant.js
// TODO: CLEANUP remove this comment once Regions goes live)
export const customerApplication = {
  analytics: {
    heap: true,
    googleTagManager: true
  },
  header: {
    questions: true,
    contactUs: null,
    show_badge: false
  },
  sidebar: {
    images: {
      security_and_privacy: require("@amount/frontend-styles/src/images/dec/dec-thumb-seal-small.png"),
      questions: require("@amount/frontend-styles/src/images/dec/dec-thumb-help-small.png"),
      better_business_bureau: require("@amount/frontend-styles/src/images/partners/regions/logo/logo-bbb.png"),
    }
  },
  subheader: {
    images: {
      discount: require('@amount/frontend-styles/src/images/partners/regions/dec/dec-discount.svg'),
    }
  },
  useAmountModalForSessionExpiry: true,
};

export const ipDash = {
  analytics: {
    heap: true,
    googleTagManager: false
  }
};

export const customerHome = {
  analytics: {
    heap: true,
    googleTagManager: true
  }
};

require("!!inline-loader!@amount/frontend-styles/src/images/partners/regions/icons/icon-map.svg");
